import { useStaticQuery, graphql } from 'gatsby';

export const useSiteMetaData = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          ...SiteMetadata
        }
      }
    `
  );
  return site.siteMetadata;
};
